import config from "../config.json";

export const conf = {
  ...config,
};

export default conf;
